export default __webpack_public_path__ + "static/media/mastercard.e404d1bc.svg";